/**
 * @file
 * @prettier
 */

import { InitializeAutoDebitEnrollmentPages } from "./AutoDebitEnrollmentPages.js";

export function InitializeDLSecureBorrowerAutoDebitEnrollment2completePage() {
  InitializeAutoDebitEnrollmentPages();

  // bank account validation dialog ***************************************
  $("#divBAValidationPopup").dialog({
    dialogClass: "PopupDialog",
    modal: true,
    autoOpen: false,
    title: "",
    width: "75%",
    maxWidth: 400,
    resizable: false,
    /*         position: { my: "center", at: "center", of: window }*/
  });

  $(".QuestionClass").click(function (e) {
    e.preventDefault();
    $("#divBAValidationPopup")
      .dialog("option", "position", {
        at: "center top+175",
        of: "#MainContent",
      })
      .dialog("open");
  });
}
